import React, { useEffect, useState } from "react";
import { useSchoolDetailsContext } from "../context/SchoolDetailsContext";
import { useLocation } from "react-router-dom";
import { useLoader } from "../context/LoaderContext";
import { fetchSchoolDetails } from "../api/SchoolDetailsApi";
import Preloader from "../helper/Preloader";
import Animation from "../helper/Animation";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import FooterThree from "../components/FooterThree";
import { fetchgalleryImages } from "../api/GalleryApi";
import GalleryViewSction from "../components/GalleryViewSction";
import { FetchAllApi } from "../components/FetchAllApi";
import { useAllDataContext } from "../context/AllDataContext";

const GalleryViewPage = () => {
  const location = useLocation();
  const { schoolDetailsData, setSchoolDetailsData } = useSchoolDetailsContext();
  const [subBreadcrumbTitle, setSubBreadcrumbTitle] = useState();
  const { setLoading } = useLoader();
  const [galleryImagesData, setGalleryImagesData] = useState([]);
  const { allData, setAllData } = useAllDataContext();

  const galleryViewBannerData = allData.allBannerData[0]?.gallery_preview_title;

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchgalleryImages()])
      .then(([galleryImage]) => {
        setGalleryImagesData(galleryImage);
        setTimeout(() => {
          setLoading(false);
        }, 500);
      })
      .catch(() => {
        console.error("Server Error");
        setTimeout(() => {
          setLoading(false);
        }, 500);
      });
  }, [setLoading]);
  FetchAllApi({ schoolDetailsData, setAllData, setLoading });

  useEffect(() => {
    if (schoolDetailsData.length === 0) {
      Promise.all([fetchSchoolDetails()])
        .then(([schoolDetailsData]) => {
          setSchoolDetailsData(schoolDetailsData);
        })
        .catch(() => {
          console.error("Server Error");
        });
    }
  }, [schoolDetailsData.length, setSchoolDetailsData]);
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* Animation */}
      <Animation />

      {/* HeaderTwo */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb
        heading={galleryViewBannerData}
        title={"Gallery"}
        subTitle={subBreadcrumbTitle}
        goBack={true}
      />

      {/* GallerySection */}
      <GalleryViewSction
        id={location.state.id}
        galleryImagesData={galleryImagesData}
        setSubBreadcrumbTitle={setSubBreadcrumbTitle}
      />

      {/* CertificateOne */}
      {/* <CertificateOne /> */}

      {/* FooterOne */}
      <FooterThree />
    </>
  );
};

export default GalleryViewPage;
